var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{on:{"open-drawer":function($event){return _vm.$emit('open-drawer')}}})}
var staticRenderFns = []

export { render, staticRenderFns }